import { api } from "./client";
import type { EventSummary, Paged } from "./types";

export interface EventListParams {
  name?: string;
  search?: string;
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export const eventsApi = {
  list: (p: EventListParams = {}) =>
    api<Paged<EventSummary>>("/api/dashboard/events", { query: { ...p } }),
  get: (id: string) => api<EventSummary>(`/api/dashboard/events/${id}`),
  replay: (id: string) => api<{ run_ids: string[] }>(`/api/dashboard/events/${id}/replay`, { method: "POST" }),
  send: (name: string, data: unknown, user?: unknown) =>
    api<{ event_id: string; runs_created: number }>("/api/dashboard/events", {
      method: "POST",
      body: { name, data, ...(user !== undefined ? { user } : {}) },
    }),
};
